import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthorizeUser from '../pages/Authentication/AuthorizeUser';
import MainPage from '../pages/Authentication/MainPage';
// import Legacy from '../pages/Authentication/Legacy';

const authProtectedRoutes = [
    // this route should be at the end of all other routes
    // eslint-disable-next-line react/display-name
    {
        path: '/',
        exact: true,
        component: <Navigate to="/dashboard" />
    },
    { path: '*', component: <Navigate to="/dashboard" /> }
];

const publicRoutes = [
    { path: '/authorize/xp/:lang?/:uniquelink/:uniquekey/', component: <AuthorizeUser /> },
    { path: '/authorize/:uniquelink', component: <AuthorizeUser /> },
    { path: '/careplan', component: <MainPage /> }
];

export { authProtectedRoutes, publicRoutes };
